import { render, staticRenderFns } from "./materialpage.vue?vue&type=template&id=6b1e0a79&scoped=true&"
import script from "./materialpage.vue?vue&type=script&lang=js&"
export * from "./materialpage.vue?vue&type=script&lang=js&"
import style0 from "./materialpage.vue?vue&type=style&index=0&id=6b1e0a79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1e0a79",
  null
  
)

export default component.exports